module.exports = "pegasus/assets/theme5/small/6.jpg";